import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: {
          permissions: [PermissionEnum.SUMMARY_DASHBOARD],
          feature: FeaturesEnum.DASHBOARDS,
        },
        component: () => import('~/dashboard/pages/SummaryDashboard.vue'),
      },
      {
        path: '/worker-monitoring',
        name: 'tracking',
        meta: {
          permissions: [PermissionEnum.WORKER_MONITORING],
          //feature check is in the page
        },
        component: () => import('~/dashboard/pages/TrackingDashboard.vue'),
      },
      {
        path: '/login-dashboard',
        name: 'loginDashboard',
        meta: {
          permissions: [
            PermissionEnum.LOGIN_DASHBOARD,
            PermissionEnum.WORKER_MONITORING,
          ],
          feature: FeaturesEnum.DASHBOARDS,
        },
        component: () => import('~/dashboard/pages/LoginDashboard.vue'),
      },
      {
        path: '/ticket-dashboard',
        name: 'ticketDashboard',
        meta: {
          permissions: [PermissionEnum.TICKET_WALLET],
          //feature check is in the page
        },
        component: () => import('~/dashboard/pages/TicketDashboard.vue'),
      },
      {
        path: '/ticket-details',
        name: 'ticketDetails',
        meta: {
          permissions: [PermissionEnum.TICKET_WALLET],
          //feature check is in the page
        },
        component: () => import('~/dashboard/pages/TicketDetails.vue'),
      },
    ],
  },
];
